import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "content", "placeholder", "error" ]
  static values = { url: String, refreshInterval: Number }

  connect() {
    this.load()

    if (this.hasRefreshIntervalValue) {
      this.startRefreshing()
    }
  }

  disconnect() {
    this.stopRefreshing()
  }

  load() {
    fetch(this.urlValue, {headers: { "Accept": "text/html" }})
      .then(response => {
        if (response.ok){
          return response.text()
        }
      })
      .then(html => {
        this.hide(this.placeholderTarget)

        if (typeof html === "string"){
          this.contentTarget.innerHTML = html
          this.show(this.contentTarget)
        }else{
          this.hide(this.contentTarget)
          this.show(this.errorTarget)
        }
      })
  }

  refresh(e) {
    e.preventDefault()

    this.hide(this.errorTarget)

    if (e.params.keepContentVisible){
      this.hide(this.placeholderTarget)
    }else{
      this.hide(this.contentTarget)
      this.show(this.placeholderTarget)
    }

    this.load()
  }

  updateUrlAndRefresh(e) {
    e.preventDefault()

    this.urlValue = e.currentTarget.href
    this.refresh(e)
  }

  startRefreshing() {
    this.refreshTimer = setInterval(() => {
      this.load()
    }, this.refreshIntervalValue)
  }

  stopRefreshing() {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
    }
  }

  hide(el) {
    el.classList.add("hidden")
  }

  show(el) {
    el.classList.remove("hidden")
  }
}
